import { Injectable, computed, inject, signal } from '@angular/core';
import { LoginService } from '@uoa/auth';

interface UserInfo {
    upi: string;
    firstName: string;
    lastName: string;
    email: string;
    role: 'admin' | 'feeder' | null;
}

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
    private readonly loginService = inject(LoginService);

    private readonly _info = signal<UserInfo | null>(null);
    private _initPromise: Promise<void> | null = null;

    readonly upi = computed(() => this._info()?.upi ?? '');
    readonly firstName = computed(() => this._info()?.firstName ?? '');
    readonly lastName = computed(() => this._info()?.lastName ?? '');
    readonly email = computed(() => this._info()?.email ?? '');
    readonly role = computed(() => this._info()?.role ?? null);
    readonly isAdmin = computed(() => this._info()?.role === 'admin');

    initialize(): Promise<void> {
        if (!this._initPromise) {
            this._initPromise = this.load();
        }
        return this._initPromise;
    }

    private async load(): Promise<void> {
        const info = (await this.loginService.getUserInfo()) as any;
        let role: 'admin' | 'feeder' | null = null;
        const groups: string[] = (info.groups ?? []).map((g: string) => g.trim());
        console.log(groups)
        if (groups.includes('PidginAdmin_users')) role = 'admin';
        else if (groups.includes('Pidgin_users')) role = 'feeder';
        this._info.set({
            upi: info.upi ?? '',
            firstName: info.firstName ?? '',
            lastName: info.lastName ?? '',
            email: info.email ?? '',
            role,
        });
    }

    reset() {
        this._initPromise = null;
        this._info.set(null);
    }
}
